import { Menu01 } from "untitledui-js-base";
import { IconButton } from "shared/components";
import { useAuthContext } from "providers/Auth";
import logoSquare from "shared/branding/logo-square.svg";
import { Link } from "react-router-dom";

interface MobileNavBarProps {
  setIsOpenFromMobile: React.Dispatch<React.SetStateAction<boolean>>;
}

export const MobileNavBar = ({ setIsOpenFromMobile }: MobileNavBarProps) => {
  const { partner, auth } = useAuthContext();

  return (
    <div className="fixed z-[5] bg-white w-full justify-between flex md:hidden h-16 py-3 px-4 items-center border border-alpha-100">
      <div className="flex gap-1 items-center">
        <IconButton
          Icon={Menu01}
          borderLess
          className="stroke-content-200"
          onClick={() => setIsOpenFromMobile(true)}
        />

        <p className="text-content-1000 font-bold text-sm">
          {partner?.name || auth?.name || ""}
        </p>
      </div>

      <Link to="/">
        <img src={logoSquare} className="h-[30px] w-[30px]" />
      </Link>
    </div>
  );
};
